import { render } from "./JoinPinGroupView.vue?vue&type=template&id=66664bed&scoped=true"
import script from "./JoinPinGroupView.vue?vue&type=script&lang=js"
export * from "./JoinPinGroupView.vue?vue&type=script&lang=js"

import "./JoinPinGroupView.vue?vue&type=style&index=0&id=66664bed&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66664bed"]])

export default __exports__